var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":_vm.size,"viewBox":("0 0 " + _vm.actualSize + "  " + _vm.actualSize),"xmlns":"http://www.w3.org/2000/svg"}},_vm._l((_vm.paths),function(path,i){return _c('path',{key:i,attrs:{"fill":_vm.color,"d":path}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }